export const tonalPalettes = {
  primary: {
    0: '#000000',
    10: '#0C1253',
    20: '#131C7D',
    30: '#1925A7',
    40: '#1F2ED1',
    50: '#4350E3',
    60: '#727CEA',
    70: '#A1A8F1',
    80: '#D0D3F8',
    90: '#E7E9FB',
    95: '#F0F1FF',
    99: '#FAFAFA',
    100: '#FFFFFF'
  },
  secondary: {
    0: '#000000',
    10: '#1A1800',
    20: '#333000',
    30: '#4D4700',
    40: '#665F00',
    50: '#807700',
    60: '#998F00',
    70: '#B3A700',
    80: '#E6D600',
    90: '#FFEE00',
    95: '#FFF780',
    99: '#FFFEEE',
    100: '#FFFFFF'
  },
  tertiary: {
    0: '#000000',
    10: '#151516',
    20: '#2B292D',
    30: '#403E43',
    40: '#565259',
    50: '#6B676F',
    60: '#89848D',
    70: '#A6A3AA',
    80: '#C4C1C6',
    90: '#E1E0E3',
    95: '#F0F0F1',
    99: '#F9F9FE',
    100: '#FFFFFF'
  },
  error: {
    0: '#000000',
    10: '#3B0000',
    20: '#590000',
    30: '#760000',
    40: '#940000',
    50: '#DC0000',
    60: '#FF4A4A',
    70: '#FF6E6E',
    80: '#FFB4A9',
    90: '#FFDAD4',
    95: '#FFEDE9',
    99: '#FFF8F6',
    100: '#FFFFFF'
  },
  success: {
    0: '#000000',
    10: '#012100',
    20: '#013100',
    30: '#014100',
    40: '#015200',
    50: '#027C00',
    60: '#03A700',
    70: '#04D200',
    80: '#56FF54',
    90: '#ABFFA9',
    95: '#D5FFD4',
    99: '#ECFFEB',
    100: '#FFFFFF'
  },
  neutral: {
    0: '#000000',
    10: '#141414',
    20: '#1F1F1F',
    30: '#292929',
    40: '#333333',
    50: '#5C5C5C',
    60: '#858585',
    70: '#ADADAD',
    80: '#D6D6D6',
    85: '#E8E8E8',
    90: '#EBEBEB',
    95: '#F3F3F3',
    99: '#FAFAFA',
    100: '#FFFFFF'
  },
  neutralWarm: {
    80: '#D1D1D1',
    85: '#E0E0E0',
    90: '#E8E8E8',
    100: '#FFFFFF'
  },
  neutralVariant: {
    0: '#000000',
    10: '#1A1B23',
    20: '#2F3038',
    30: '#45464F',
    40: '#5D5E67',
    50: '#76767F',
    60: '#90909A',
    70: '#AAAAB4',
    80: '#C6C5CF',
    90: '#E2E1EC',
    95: '#F0EFFA',
    99: '#FDFBFF',
    100: '#FFFFFF'
  }
}

export const tonalPalettesMSM = {
  primary: {
    0: '#000000',
    10: '#040308',
    20: '#100B1E',
    30: '#20163B',
    40: '#291D4C',
    50: '#4A3C70',
    60: '#756899',
    70: '#8E82B1',
    80: '#B7B3D2',
    90: '#D1CFE3',
    95: '#E5E4F0',
    99: '#F1F1F6',
    100: '#FFFFFF'
  },
  secondary: {
    0: '#000000',
    10: '#280117',
    20: '#3C0123',
    30: '#6C1E58',
    40: '#8C2E72',
    50: '#D55CA8',
    60: '#FC7BC5',
    70: '#F2A6D9',
    80: '#F4B8E4',
    90: '#F7D1EF',
    95: '#FCF0FA',
    99: '#FFF9FE',
    100: '#FFFFFF'
  },
  tertiary: {
    0: '#000000',
    10: '#11122C',
    20: '#1D1E49',
    30: '#3A3973',
    40: '#525096',
    50: '#5B5EBF',
    60: '#8987DC',
    70: '#A9A7FA',
    80: '#B5B3FF',
    90: '#D9D8FF',
    95: '#F0F2FE',
    99: '#F2F6FE',
    100: '#FFFFFF'
  },
  error: {
    0: '#000000',
    10: '#3B0000',
    20: '#590000',
    30: '#760000',
    40: '#940000',
    50: '#940000',
    60: '#FF4A4A',
    70: '#FF6E6E',
    80: '#FFB4A9',
    90: '#FFDAD4',
    95: '#FFEDE9',
    99: '#FFF8F6',
    100: '#FFFFFF'
  },
  success: {
    0: '#000000',
    10: '#012100',
    20: '#013100',
    30: '#014100',
    40: '#015200',
    50: '#027C00',
    60: '#03A700',
    70: '#04D200',
    80: '#56FF54',
    90: '#ABFFA9',
    95: '#D5FFD4',
    99: '#ECFFEB',
    100: '#FFFFFF'
  },
  neutral: {
    0: '#000000',
    10: '#141414',
    20: '#1F1F1F',
    30: '#292929',
    40: '#333333',
    50: '#5C5C5C',
    60: '#858585',
    70: '#ADADAD',
    80: '#D6D6D6',
    90: '#EBEBEB',
    95: '#F3F3F3',
    99: '#FAFAFA',
    100: '#FFFFFF'
  },
  neutralWarm: {
    80: '#D1D1D1',
    85: '#E0E0E0',
    90: '#E8E8E8',
    100: '#FFFFFF'
  },
  neutralVariant: {
    0: '#000000',
    10: '#1A1B23',
    20: '#2F3038',
    30: '#45464F',
    40: '#5D5E67',
    50: '#76767F',
    60: '#90909A',
    70: '#AAAAB4',
    80: '#C6C5CF',
    90: '#E2E1EC',
    95: '#F0EFFA',
    99: '#FDFBFF',
    100: '#FFFFFF'
  }
}

// Added in as new vars for now since these are colours that don't exist but are in the designs.
// Think the whole design system needs to be visited at some point so we can get better consistency between LandingPages/Appform/MyZuto
export const formlessColors = {
  // Surfaces
  surfaceBlueSoft: '#E5F0FF',
  surfaceGreenSoft: '#DFFBEA',
  surfaceSkySoft: '#E0F5FF',
  surfacePurpleSoft: '#F4E9FF',
  surfaceBlueSoftAlt: '#DBEAFE',
  surfaceAmberSoft: '#FEF3C7',
  surfacePurpleSoftAlt: '#F5EEFF',
  surfaceIndigoSoft: '#EEF2FF',
  surfaceSkySoftAlt: '#E0F2FE',

  // Icons
  iconBlue: '#2563EB',
  iconGreen: '#16A34A',
  iconSky: '#0EA5E9',
  iconPurple: '#7C3AED',
  iconAmber: '#D97706',
  iconIndigo: '#4F46E5',
  iconSkyAlt: '#0284C7',

  // Accents / interstitial
  accentGreen: '#2CC092',

  // Text
  textMuted: '#4B5563',
  bodyTextMuted: 'rgba(0,0,0,0.7)',
  trustTextStrong: 'rgba(0,0,0,0.85)',

  // Progress / trust / handover
  progressActive: 'rgba(44,192,146,0.8)',
  progressInactive: 'rgba(0,0,0,0.2)',
  trustIconBg: 'rgba(44,192,146,0.12)',
  handoverConnectorGradient:
    'linear-gradient(90deg, #000000, #2CC092, #000000)',

  // Other
  borderSubtle: '#E5E7EB',
  pageBgGrey: '#8C8C8C',

  // Brand
  brandYellow: '#FFE70C'
} as const
